









































































































import Vue, { PropType } from "vue";
import { mapMutations } from "vuex";
import { Mutations } from "@/store/index";
import { Calculation } from "@/models/Calculation";
import { Federation, AssociationUtils } from "@/models/Federation";
import ErrorLabel from "./ErrorLabel.vue";
import { Radio, RadioGroup } from "@/components";
import AssociationSelect from "./AssociationSelect.vue"; // Cyåress doesn't run locally with alias import :( like this import { AssociationSelect } from "@/components";

export default Vue.extend({
  name: "CreateCalculationDialog",
  components: { ErrorLabel, Radio, RadioGroup, AssociationSelect },
  props: {
    calculations: {
      type: Array,
      default: () => null,
    },
    value: Boolean,
    initialCalc: {
      type: Object as PropType<Calculation>,
      default: () => undefined,
    },
  },
  data() {
    return {
      year: new Date().getFullYear(),
      organizationName: "",
      calculationType: "",
      templateType: "",
      membershipType: 0,
    };
  },
  computed: {
    getCalculationTypes() {
      return [
        {
          text: "Kontingent",
          value: "Contingent",
        },
        {
          text: "Serviceavgift",
          value: "ServiceFee",
        },
      ];
    },
    getMembershipTypes() {
      return [
        {
          value: 0,
          text: "Ordinært",
        },
        {
          value: 1,
          text: "Fagmedlemskap",
        },
        {
          value: 2,
          text: "Ekstraordinært",
        },
      ];
    },
    associations(): Array<Federation> {
      return this.$store.getters.associations;
    },
    canCreate(): boolean {
      return (
        this.year >= 2000 &&
        this.organizationName !== "" &&
        this.calculationType !== "" &&
        (this.templateType !== "" ||
          this.previousYearCalculationExists == false) &&
        this.calculationAlreadyExists == false &&
        this.selectedAssociation !== undefined
      );
    },
    previousYearCalculation(): Calculation | undefined {
      return (this.calculations as Array<Calculation>)?.find(
        (x) =>
          x.year == this.year - 1 &&
          x.calculationType == this.calculationType &&
          x.membershipType == this.membershipType &&
          x.nhoNumber == this.selectedAssociation?.nhoNumber
      );
    },
    previousYearCalculationExists(): boolean {
      return this.previousYearCalculation !== undefined;
    },
    calculationAlreadyExists(): boolean {
      return (this.calculations as Array<Calculation>)?.some(
        (x) =>
          x.year == this.year &&
          x.calculationType == this.calculationType &&
          x.membershipType == this.membershipType &&
          x.nhoNumber == this.selectedAssociation?.nhoNumber
      );
    },
    selectedAssociation(): Federation | undefined {
      return this.findOrganizationByName() || undefined;
    },
    model: {
      get(): boolean {
        return this.value;
      },
      set(val: boolean): void {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    initialCalc(calc: Calculation | undefined) {
      if (typeof calc !== "undefined") {
        this.organizationName =
          this.associations?.find(
            (a: Federation) => a.nhoNumber === calc.nhoNumber
          )?.name ?? "";
        this.year = calc.year;
        this.calculationType = calc.calculationType;
        this.membershipType = calc.membershipType;
      } else {
        this.organizationName = "";
        this.year = new Date().getFullYear();
        this.calculationType = "";
        this.membershipType = 0;
      }
    },
  },
  methods: {
    ...mapMutations([Mutations.SET_OPEN_CALCULATION]),
    create(dialog: any) {
      dialog.value = false;

      let calculation = {
        year: this.year,
        calculationType: this.calculationType,
        customCalculationText: "",
        childNhoNumber: 0,
        childPriorityClass: 0,
        triggeredByMembershipNhoNumber: null,
        nhoNumber: this.selectedAssociation?.nhoNumber,
        membershipType: this.membershipType,
        organizationNumber: AssociationUtils.getOrganizationNumberByMo(
          this.associations,
          this.selectedAssociation?.nhoNumber ?? -1
        ),
        blocks: [],
        hasUnsavedChanges: true,
        isActive: true,
        childOrganizationCalculations: [],
      } as Calculation;

      if (this.templateType == "copy" && this.previousYearCalculation)
        calculation.blocks = this.previousYearCalculation.blocks;

      this.setOpenCalculation(calculation);
      this.$router.push({
        name: "Calculation",
        query: {
          org: calculation.nhoNumber.toString(),
          type: calculation.calculationType.toString(),
          year: calculation.year.toString(),
          membershipType: calculation.membershipType.toString(),
        },
      });
    },
    findOrganizationByName(): Federation | undefined {
      return (
        (this.associations as Array<Federation>).find(
          (o) => o.name == this.organizationName
        ) || undefined
      );
    },
  },
});
